import React from "react";
import ReactQuill, { Quill } from "react-quill";

import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module";
import ImageFormat from "./utils/ImageFormat";
import htmlEditButton from "quill-html-edit-button";

const quillFonts = [
  "arial",
  "calibri",
  "courier",
  "georgia",
  "lucida",
  "open",
  "roboto",
  "tahoma",
  "times",
  "trebuchet",
  "verdana",
];

const Font = Quill.import("formats/font");
Font.whitelist = quillFonts;
Quill.register(Font, true);

Quill.register("modules/ImageResize", ImageResize);
Quill.register(ImageFormat, true);
Quill.register("modules/htmlEditButton", htmlEditButton);

const Editor = ({ input, label, meta: { error, touched } }) => {
  return (
    <div>
      <label>{label}</label>
      <ReactQuill
        {...input}
        theme={"snow"}
        onChange={(newValue, delta, source) => {
          if (source === "user") {
            input.onChange(newValue);
          }
        }}
        onBlur={(range, source, quill) => {
          input.onBlur(quill.getHTML());
        }}
        modules={Editor.modules}
        formats={Editor.formats}
        bounds={".editor"}
        placeholder=""
      />
      <div className="text-danger" style={{ marginBottom: "20px" }}>
        {touched && error}
      </div>
    </div>
  );
};

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
  ImageResize: { parchment: Quill.import("parchment") },
  toolbar: [
    [{ header: "2" }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
  htmlEditButton: {},
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
  "alt",
  "height",
  "width",
  "style",
];

export default Editor;



// WEBPACK FOOTER //
// ./src/components/common/Editor.js